import { render, staticRenderFns } from "./BriqPriceInput.vue?vue&type=template&id=57fdfb79&scoped=true&lang=pug&"
import script from "./BriqPriceInput.vue?vue&type=script&lang=js&"
export * from "./BriqPriceInput.vue?vue&type=script&lang=js&"
import style0 from "./BriqPriceInput.vue?vue&type=style&index=0&id=57fdfb79&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fdfb79",
  null
  
)

export default component.exports